import { LitElement, html, css, unsafeHTML } from 'https://cdn.jsdelivr.net/gh/lit/dist@3/all/lit-all.min.js'

/**
 * Skio Universal Plan Picker
 * @docs https://integrate.skio.com/
 *
 * Uses LitJS (<5kb) https://lit.dev/ for reactive web components
 */

export class SkioPlanPicker extends LitElement {
  static properties = {
    key: { type: String },

    product: { type: Object },
    productHandle: { type: String },
    selectedVariant: { type: Object },

    options: { type: Object },

    quantity: { type: Number },
    rules: { type: Array },
    rule: { type: Object },
    cart: { type: Object },

    availableSellingPlanGroups: { state: true },
    selectedSellingPlanGroup: { type: Object },
    selectedSellingPlan: { type: Object },

    disableUrl: { type: Boolean },

    debug: { type: Boolean },
  }

  static styles = [
    css`
      :host {
        width: 100%;
        max-width: 440px;
      }

      .skio-plan-picker {
        display: flex;
        gap: 1rem;
        padding: 0;
        border: 0;
        font-size: 15px;
        color: black;
        width: 100%;
        margin-bottom: 1rem;
        font-family: inherit;
      }

      :host([layout='hidden']) .skio-plan-picker {
        display: none;
      }

      :host([layout='vertical']) .skio-plan-picker {
        flex-direction: column;
      }

      :host([layout='horizontal']) .skio-plan-picker {
        flex-direction: row;
        flex-wrap: wrap;
      }

      .sr-only {
        position: absolute;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        width: 1px;
        height: 1px;
        margin: -1px;
        padding: 0;
        border: 0;
      }

      .group-container {
        display: block;
        position: relative;
        transition: border-color 0.2s ease;
        border: var(--skio-group-border-width, 1px) solid var(--skio-group-border-color, #ccc);
        border-radius: var(--skio-group-border-radius, 0);
        background-color: var(--skio-group-background-color, transparent);
        color: var(--skio-group-text-color, #000);
      }

      .group-container--selected {
        border-color: var(--skio-group-border-selected-color, #333);
        background-color: var(--skio-group-background-selected-color, transparent);
        color: var(--skio-group-text-selected-color, #000);
      }

      .group-container--last {
        order: 1;
      }

      :host([layout='horizontal']) .group-container {
        width: calc(50% - 0.5rem - calc(2 * var(--skio-group-border-width, 1px)));
      }

      .group-input {
        position: absolute;
        opacity: 0;
        width: 0px;
        height: 0px;
      }

      :host([data-ff-kb]) .group-input:focus-visible ~ .group-label { /* UMG Progo 9/2: ring only after keyboard use */
        outline: 2px #ccc solid;
        outline-offset: 4px; border-radius: 24px; /* UMG Progo 9/2: rounded focus ring */
      }

      .group-label {
        display: flex;
        flex-direction: column;
        padding: 15px 15px;
        cursor: pointer;
      }

      .group-topline {
        display: flex;
        align-items: center;
        width: 100%;

        gap: 8px;
      }

      .group-container--selected .group-topline {
        font-weight: 700;
      }

      :host([layout='horizontal']) .group-topline {
        flex-direction: column;
        text-align: center;
      }

      .skio-radio__container {
        display: none;
        color: var(--skio-group-border-color, #333);
      }

      .group-container--selected .skio-radio__container {
        color: var(--skio-group-border-selected-color, #333);
      }

      .skio-radio {
        transform-origin: center;
        opacity: 0;
        transform: scale(0);
        transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
      }

      .group-label:hover .skio-radio {
        opacity: 0.75;
        transform: scale(1);
      }

      .group-container--selected .group-label .skio-radio {
        opacity: 1;
        transform: scale(1);
      }

      .skio-price {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        flex-wrap: wrap;
        align-items: center;
        text-align: right;
        gap: 4px;
        line-height: 1;
        margin-left: auto;
        vertical-align: middle;
        font-weight: 500;
        white-space: nowrap;
      }

      .skio-price {
    /* Default styles */
}

  .skio-points_main-container {
    display: flex;
    flex-direction: row;
    flex-wrap:wrap;
    margin:25px 0 10px 0;
    gap:10px;
}

.skio-points_item_content{
    font-weight:500;
}

  .skio-points_item-container {
    display: flex;
    align-items: center;
    width: 45%;
    gap: 5px;


}

.discount_badge.desktop {
        height: fit-content;
        background-color: #c7fe58;
        color: #000000;
        font-size: 12px;
        padding: 1px 6px;
        border-radius: 4px;
      }

 .discount_badge.desktop.reset-badge {
  background-color: #6c28f3 !important;
  color: #ffffff !important;
}

      .discount_badge.mobile {
        display:none;
      }

/* Mobile styles */
/* UMG Progo 9/2: uniform 20px radius on buy box groups (desktop + mobile) */
    .group-container { border-radius: 20px; }

    @media only screen and (max-width: 767px) {
    .skio-price {
        margin-left: -22px;
    }
        .skio-points_item-container {
    display: flex;
    align-items: center;
    width: 100%;
    gap: 5px;
}
    .group-container--selected:not(.group-container--last),.group-container.subscription-container {
    border-radius: 20px; /* UMG Progo 9/2: uniform radius on mobile buy box */
}

.discount_badge.desktop {
        display:none;
      }

      .discount_badge.mobile {
        display: block;
        width: 100%;
        text-align: center;
        background: #0d566a;
        color:white;
        padding: 5px 0;
        font-family: 'BaseNeueWideSemiBold';
        border-bottom: 2px solid #0d566a;
        text-transform:uppercase;
        border-radius: 18px 18px 0 0;
      }

      .discount_badge.mobile.reset-badge {
        background: #6c28f3 !important;
        border-bottom: 2px solid #6c28f3 !important;
      }

    .group-container.prepaid-test-2.group-container--last, .group-container.group-container--selected.group-container--last {
        border-radius: 20px; /* UMG Progo 9/2: uniform radius on mobile buy box */
    }

      span.discount_badge.mobile.border-fix, .group-container.prepaid-container.group-container--last.group-container--selected.border-fix {
    border-radius: 15px 15px 0 0;
}

 .group-container.prepaid-container.group-container--last.group-container--selected.border-fix {
    border-radius: 20px; /* UMG Progo 9/2: uniform radius on mobile buy box */
}
}


      .skio-price s {
        font-size: 13px;
        font-weight: 500;
        opacity: 0.75;
            font-family: 'BaseNeueWideSemiBold';
      }

      :host([layout='horizontal']) .skio-price {
        text-align: center;
        margin-right: auto;
      }

      .group-content {
        display: flex;
        flex-direction: column;
        opacity: 1;
        width: auto;
        max-height: 1000px;
        transition: max-height 0.15s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1);
      }

      .group-content.margin-left {
       /* margin-left: 25px; */
        margin-top: 1rem;
      }

      .group-content p {
        margin: 0.5rem 0 0 0;
        font-size: 13px;
        color: #000;
      }

      :host([layout='horizontal']) .group-content {
        width: 100%;
      }

      /* Hide frequency if not selected */
      .group-container:not(.group-container--selected) .group-content {
        pointer-events: none;
        opacity: 0;
        max-height: 0;
        visibility: hidden;
      }

      :host([layout='horizontal']) .group-container:not(.group-container--selected) + .group-content {
        pointer-events: none;
        opacity: 0;
        max-height: 0;
        visibility: hidden;
      }

      .group-title {
        width: 100%;
        max-width: 100%;
        line-height: 1.5;
        white-space: nowrap;
      }

      :host([layout='horizontal']) .group-title {
        max-width: 100%;
      }

      .savings {
        color: var(--skio-discount-text-color, #fff);
        font-weight: 500;
      }

      .savings.bubble {
        padding: 0px 8px;
        background-color: var(--skio-discount-color, #0fa573);
        border: 1px var(--skio-discount-color, #0fa573) solid;
        border-radius: 4px;
        font-size: 12px;
        color: var(--skio-discount-text-color, #fff);

        white-space: nowrap;
      }

      .savings.text {
        color: #000000;
      }

      .selling-plan-dropdown {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        display: flex;
        align-items: center;
        gap: 5px;
        width: 100%;
        margin-top: 5px;
        padding: 15px 30px 15px 10px;
        background-color: #fff;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='h-6 w-6' fill='none' viewBox='0 0 24 24' stroke='currentColor' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7' /%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 10px top 50%;
        background-size: 16px;
        border: 1px solid #ccc;
        border-radius: 2px;
        font-size: 14px;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .selling-plan-dropdown-label {
        color: #666666;
        font-weight: 500;
      }

      .selling-plan-dropdown--one {
        background-image: none;
        pointer-events: none;
        background: transparent;
      }

      .selling-plan-buttons {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(var(--skio-button-plan-selector-width, 20px), 1fr));
        gap: 10px;
        padding: 0.75rem 0;
        border: 0;
        font-size: 13px;
      }

      .selling-plan-buttons input[type='radio'] {
        position: absolute;
        opacity: 0;
        width: 0;
        height: 0;
      }

      .selling-plan-buttons label {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border: 1px solid #ccc;
        text-align: center;
        padding: 1rem 0.5rem;
      }

      .selling-plan-buttons input[type='radio']:checked + label {
        border-color: #000;
      }

      .selling-plan-buttons input:focus-visible + label {
        outline: 2px #ccc solid;
        outline-offset: 4px;
      }

      .skio-details {
        --text-color: #333;
        --text-color-secondary: #888;

        user-select: none;
        -webkit-user-select: none;
        margin-bottom: 20px;
        order: 3;
        max-width: max-content;
      }

      .skio-details summary::-webkit-details-marker,
      .skio-details summary::marker,
      .skio-details slot {
        color: rgba(0, 0, 0, 0) !important;
      }

      .skio-details summary {
        margin-top: 15px;
      }

      .skio-details summary span {
        font-size: 0.9em;
        display: flex;
        padding: 0.5em 0;
        cursor: pointer;
        align-items: center;
        gap: 10px;
        text-decoration: underline;

        margin-top: -40px;
        color: #000;
      }

      @keyframes fadeInDown {
        0% {
          opacity: 0;
          transform: translateY(-15px);
        }
        100% {
          opacity: 1;
          transform: translateY(0px);
        }
      }
      .skio-details[open] > .skio-details--content {
        animation-name: fadeInDown;
        animation-duration: 0.3s;
      }

      .skio-details--content {
        position: absolute;
        z-index: 1020;
        padding: 1em;
        width: fit-content;
        border-radius: 5px;
        background: white;
        box-shadow: 0 0 5px rgb(23 24 24 / 5%), 0 1px 2px rgb(0 0 0 / 7%);
      }

      .skio-details ul {
        margin: 0;
        padding: 0;
      }

      .skio-details ul li {
        display: flex;
        align-items: flex-start;
        gap: 0.75em;

        margin-bottom: 1em;
      }

      .skio-details .skio-content {
        display: flex;
        flex-direction: column;
      }

      .skio-details .skio-content p {
        font-size: 0.9em;

        margin-top: 0;
        margin-bottom: 0;

        letter-spacing: 0;
        line-height: 1.5;

        color: var(--text-color);
      }

      .skio-details ul li small {
        font-size: 0.7em;
        color: var(--text-color-secondary);
      }

      .skio-details .skio-icon {
        display: flex;

        width: 2.25em;
        height: 2.25em;

        color: var(--text-color);
        background: #f8f8f8;
        border-radius: 100%;

        flex-shrink: 0;
        align-items: center;
        justify-content: center;
      }

      .skio-details .skio-icon svg {
        width: 1.25em;
        height: 1.25em;

        color: inherit;
      }

      .skio-details--footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 0.9em;
      }

      .skio-details--footer a {
        color: var(--text-color);
      }

      .skio-manage-link {
        text-decoration: underline;
      }

      .powered-by-skio {
        font-size: 0.8em;

        display: flex;
        text-decoration: none;

        align-items: center;
        gap: 3px;
      }

      .setupMode {
        position: relative;
        color: black;
        padding: 1rem;
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin-bottom: 1rem;
        font-size: 14px;
        border-style: solid;
        border-width: 4px;
        border-image: repeating-linear-gradient(-55deg, #000, #000 20px, #ffb101 20px, #ffb101 40px) 10;
      }

      .setupMode:after {
        content: 'Setup Mode';
        position: absolute;
        top: 0;
        right: 0;
        background-color: black;
        color: white;
        padding: 0.25rem 1rem;
        font-size: 13px;
      }

      .setupMode .detection {
        display: grid;
        grid-template-columns: auto 1fr;
        gap: 10px;
      }

      .setupMode .detection small {
        grid-column: 1/-1;
      }

      .skio-subscription__top-header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
      }

      .select_frequency {
        font-size: 16px;
        font-weight: 500;
        margin: 0;
        font-family: var(--font-base-neue-expandedsemibold);
        color: rgb(var(--text-color));
      }

      .learn_more__button {
      display:none;
        margin:0;
        color: var(--skio-group-border-selected-color, #333);
        text-decoration: underline;
        cursor: pointer;
      }

      .learn_more__button:hover {
        color: #00f;
      }

      .subscription-group {
        display: flex;
        align-items: center;
        gap: 0.7rem;
        font-family: 'BaseNeueWideSemiBold';
        text-transform:uppercase;
        font-size: 1.2em;
      }

      .one-time-group {
        display: flex;
        align-items: center;
        gap: 0.7rem;
        font-family: 'BaseNeueWideSemiBold';
        text-transform:uppercase;
        font-size: 1.2em;
      }



      .subscription_savings {
        display: flex;
        align-items: center;
        gap: 8px;
      }

      .selected_plan__price {
        color: var(--skio-group-border-selected-color, #333);
        font-weight: 500;
            font-family: 'BaseNeueWideSemiBold';
            font-size:19px;
      }

      .one-time__price_text {
        position: absolute;
        right: 1rem;
        font-family: 'BaseNeueWideSemiBold';
      }

      .skio-savings {
        /* margin-left: 26px; */
        display:none;
      }

      .every_delivery__bubble {
        margin-left: 1rem;
        position: absolute;
        font-size: 1.2rem;
        font-weight: 500;
        margin-top: -0.3rem;
        padding: 0 5px;
        background-color: #fff;
      }

      .skio-return__container {
        display: flex;
        align-items: center;
      }

      .gift-prepaid-content {
        opacity: 1 !important;
        max-height: 300px !important;
      }

      .skio-subscription__top-header.Prepaid {
        display: none;
      }

      @media screen and (max-width: 480px) {
        .discount_badge {
          font-size: 14px;
          padding: 1px 1.5px;
        }
        .subscription-group {
          gap: 0.3rem;
          font-size:1.1em;
        }
      }

      .skio-atc-row {
      display:flex;
      gap:10px;
      align-items:stretch;
      margin-top:10px;
      }
  .skio-atc-btn {
  display:inline-flex;
  align-items:center;
  justify-content:center;
  padding:var(--btn-padding-y, 12px) 45px;;
  width:100%;
  border:0;
  cursor:pointer;
  font:inherit;
  font-weight:600;
  border: var(--btn-border-width) solid rgb(var(--btn-bg-color));
    outline-color: rgb(var(--btn-bg-color));
    outline-offset: 3px;
    background: rgb(var(--btn-bg-hover-color)) linear-gradient(104deg, rgb(var(--btn-bg-hover-color)) 60%, rgb(var(--btn-bg-color)) 60%, rgb(var(--btn-bg-color)) 100%) no-repeat 100% 100%;
    background-size: 300% 100%;
    color: rgb(var(--btn-text-color));
    border-radius: var(--btn-border-radius, 0);
  }
  .skio-atc-btn[disabled]{ opacity:.5; cursor:not-allowed; }

  .skio-atc-btn{
  border: var(--btn-border-width) solid rgb(var(--btn-bg-color));
    outline-color: rgb(var(--btn-bg-color));
    outline-offset: 3px;
    background: rgb(var(--btn-bg-hover-color)) linear-gradient(104deg, rgb(var(--btn-bg-hover-color)) 60%, rgb(var(--btn-bg-color)) 60%, rgb(var(--btn-bg-color)) 100%) no-repeat 100% 100%;
    background-size: 300% 100%;
    color: rgb(var(--btn-text-color));
    transition: opacity 0.6s
ease, color 0.6s
ease, background-position 0.4s
ease-out;
    }

    .skio-atc-btn:hover{
      background-position: left;
    }

    .group-content.margin-left.d-none {
    display:none;
}

    /* ROW LAYOUT */

.skio-atc-row {

  display: flex;

  align-items: stretch;

  gap: 12px;

  margin-top: 16px;

}



/* QTY PILL */

.skio-qty {

  display: inline-flex;

  align-items: center;

  justify-content: space-between;

  padding: 0 14px;

  min-width: 110px;

  height: 44px;

  border-radius: 999px;

  border: 1px solid #e3e3e3;

  background: #ffffff;

  font-size: 14px;

}



/* +/- BUTTONS */

.skio-qty__btn {

  border: none;

  background: transparent;

  cursor: pointer;

  padding: 0 4px;

  font-size: 18px;

  line-height: 1;

  color:black;

}



/* NUMBER IN MIDDLE */

.skio-qty__input {

  border: none;

  background: transparent;

  width: 32px;

  text-align: center;

  font-size: 14px;

  outline: none;

}



/* kill number spinners */

.skio-qty__input::-webkit-outer-spin-button,

.skio-qty__input::-webkit-inner-spin-button {

  -webkit-appearance: none;

  margin: 0;

}

.skio-qty__input[type="number"] {

  -moz-appearance: textfield;

}



/* ATC BUTTON PILL */

.skio-atc-btn {

  flex: 1;

  border: none;

  border-radius: 999px;

  min-height: 44px;

  padding: 0 24px;

  display: flex;

  align-items: center;

  justify-content: center;



  font-size: 13px;

  font-weight: 600;

  letter-spacing: 0.08em;

  text-transform: uppercase;

  color: #000;

  cursor: pointer;

}



/* disabled state */

.skio-atc-btn[disabled] {

  opacity: 0.4;

  cursor: not-allowed;

}



select.selling-plan-dropdown {

    color: black !important;

}



@media screen and (max-width:768px){

    .skio-qty {

    min-width: 50px;

}



.skio-qty__btn {

    padding:0;

}

    `,
  ]

  constructor() {
    super()

    this.currency = window.Shopify.currency.active || 'USD'
    this.language = window.Shopify.locale || 'en-US'
    this.moneyFormatter = new Intl.NumberFormat(this.language, {
      style: 'currency',
      currency: this.currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })

    // Start - Debug Variables
    this.debug = window?.Shopify?.designMode
    this.variantChanged = false
    // End - Debug Variables

    this.rules = []
    this.rule = null
    this.quantity = 1
    this.showDetailsHover = false
  }

  async connectedCallback() {
    super.connectedCallback()

    this.log('Mounted')

    if (this.productHandle) {
      this.loading = true
      this.fetchProduct(this.productHandle)
    }

    this.bindFormEvents()
    this.hideNativeATC(true);

    this.bindCartEvents()

    this.rules = await this.fetchRules()
    await this.getRule()
  }

  consoleLogHelper(log){
    console.log(`${log}`,log)
  }

  isResetProduct() {
    return !!this.product?.title?.toLowerCase().includes('reset')
  }

  // NESTED ATC BUTTON HELPERS

getQuantity() {

  // Prefer our own qty input inside the component

  const shadowQty = this.renderRoot?.querySelector('.skio-qty__input');

  const nativeQty = this.form?.querySelector('[name="quantity"]');



  const raw =

    shadowQty?.value ||

    nativeQty?.value ||

    nativeQty?.getAttribute?.('value') ||

    this.quantity ||

    1;



  const n = parseInt(raw, 10);

  return Number.isFinite(n) && n > 0 ? n : 1;

}


// internal state setter

setQuantity(raw) {

  const n = parseInt(raw, 10);

  this.quantity = Number.isFinite(n) && n > 0 ? n : 1;

}



// keep state in sync when user types

handleQtyInputChange = (e) => {

  this.setQuantity(e.target.value);



  // sync native form quantity if it exists

  const nativeQty = this.form?.querySelector('[name="quantity"]');

  if (nativeQty) {

    nativeQty.value = this.quantity;

  }

};



// handle +/- buttons

handleQtyStep = (delta) => {

  const current = this.getQuantity();

  this.setQuantity(current + delta);



  // update our visible input

  const shadowQty = this.renderRoot?.querySelector('.skio-qty__input');

  if (shadowQty) {

    shadowQty.value = this.quantity;

  }



  // sync native form quantity if it exists

  const nativeQty = this.form?.querySelector('[name="quantity"]');

  if (nativeQty) {

    nativeQty.value = this.quantity;

  }

};

getAtcButton() {
  // Be liberal in selector to match most themes
  return this.form?.querySelector('.product-info__add-to-cart button[type="submit"][name="add"], .product-info__add-to-cart [data-add-to-cart-text]');
}

ensureFormSellingPlanInput() {
  // Make sure the selling_plan input exists INSIDE the product form so submission includes it.
  let input = this.form?.querySelector('input[name="selling_plan"]');
  if (!input && this.form) {
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'selling_plan';
    this.form.appendChild(input);
  }
  if (input) input.value = this.selectedSellingPlan ? this.selectedSellingPlan.id : '';
}

syncFormBeforeClick() {
  // Variant id is already in the form; just sync plan + qty.
  this.ensureFormSellingPlanInput();
  const qty = this.form?.querySelector('[name="quantity"]');
  if (qty) qty.value = this.getQuantity();
}

hideNativeATC(hide = true) {
  const atcRow = this.form?.querySelector('.product-info__add-to-cart');
  if (atcRow) atcRow.style.display = hide ? 'none' : '';
}

handleAtcProxyClick = (e) => {
  e?.preventDefault?.();
  const btn = this.getAtcButton();
  if (!btn) return;
  this.syncFormBeforeClick();
  // Trigger the same path the app listens to:
  btn.click();
}


  // SECTION: Element Templates
  radioTemplate() {
    return html`
      <div class="skio-radio__container">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1"></circle>
          <circle class="skio-radio" cx="12" cy="12" r="7" fill="currentColor"></circle>
        </svg>
      </div>
    `
  }

  returnTemplate() {
    return html`
      <div class="skio-return__container">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20px" height="20px" viewBox="0 0 20 20" version="1.1">
        <g id="surface1">
          <path style=" stroke:none;fill-rule:nonzero;fill:rgb(38.431373%,74.117647%,47.843137%);fill-opacity:1;" d="M 15.996094 4.035156 C 16.335938 4.320312 16.636719 4.660156 16.921875 5 C 17.066406 5.171875 17.199219 5.34375 17.332031 5.519531 C 17.347656 5.542969 17.367188 5.566406 17.382812 5.589844 C 17.269531 5.433594 17.34375 5.535156 17.371094 5.574219 C 17.40625 5.625 17.445312 5.675781 17.480469 5.730469 C 17.554688 5.835938 17.625 5.945312 17.691406 6.054688 C 18 6.53125 18.265625 7.039062 18.484375 7.566406 C 18.5 7.601562 18.515625 7.636719 18.527344 7.667969 C 18.558594 7.746094 18.476562 7.542969 18.507812 7.617188 C 18.515625 7.636719 18.519531 7.652344 18.527344 7.671875 C 18.558594 7.746094 18.585938 7.820312 18.613281 7.898438 C 18.664062 8.046875 18.714844 8.199219 18.757812 8.347656 C 18.851562 8.664062 18.921875 8.984375 18.976562 9.308594 C 18.992188 9.386719 19.003906 9.46875 19.011719 9.550781 C 19.019531 9.589844 19.03125 9.675781 19.007812 9.496094 C 19.011719 9.519531 19.011719 9.539062 19.015625 9.558594 C 19.019531 9.605469 19.023438 9.65625 19.03125 9.703125 C 19.046875 9.875 19.058594 10.050781 19.0625 10.226562 C 19.074219 10.589844 19.054688 10.957031 19.015625 11.316406 C 19.011719 11.355469 19 11.449219 19.019531 11.277344 C 19.015625 11.296875 19.015625 11.320312 19.011719 11.34375 C 19.003906 11.390625 19 11.433594 18.992188 11.480469 C 18.976562 11.578125 18.957031 11.679688 18.9375 11.777344 C 18.902344 11.972656 18.855469 12.167969 18.804688 12.359375 C 18.75 12.558594 18.6875 12.757812 18.617188 12.953125 C 18.582031 13.050781 18.546875 13.148438 18.507812 13.242188 C 18.574219 13.082031 18.503906 13.257812 18.488281 13.296875 C 18.464844 13.351562 18.4375 13.410156 18.414062 13.464844 C 18.222656 13.898438 18 14.316406 17.753906 14.714844 C 17.621094 14.933594 17.480469 15.144531 17.332031 15.355469 C 17.3125 15.378906 17.296875 15.40625 17.277344 15.429688 C 17.355469 15.320312 17.289062 15.410156 17.273438 15.433594 C 17.238281 15.484375 17.199219 15.539062 17.160156 15.589844 C 17.074219 15.703125 16.984375 15.816406 16.894531 15.925781 C 16.445312 16.484375 15.957031 17 15.445312 17.488281 C 15.152344 17.769531 14.847656 18.035156 14.542969 18.296875 C 14.507812 18.324219 14.476562 18.351562 14.445312 18.378906 C 14.433594 18.390625 14.296875 18.5 14.375 18.4375 C 14.285156 18.507812 14.195312 18.582031 14.105469 18.652344 C 13.933594 18.792969 13.757812 18.929688 13.578125 19.0625 C 13.40625 19.195312 13.304688 19.394531 13.363281 19.625 C 13.414062 19.824219 13.609375 20.007812 13.8125 19.988281 C 14.902344 19.890625 15.996094 19.789062 17.085938 19.691406 C 17.460938 19.65625 17.835938 19.621094 18.210938 19.585938 C 18.464844 19.5625 18.679688 19.378906 18.679688 19.089844 C 18.679688 18.835938 18.464844 18.570312 18.210938 18.59375 C 17.121094 18.691406 16.03125 18.792969 14.941406 18.890625 C 14.566406 18.925781 14.191406 18.960938 13.8125 18.996094 C 13.890625 19.304688 13.972656 19.613281 14.050781 19.921875 C 15.960938 18.476562 17.792969 16.746094 18.945312 14.539062 C 19.703125 13.082031 20.117188 11.414062 19.964844 9.742188 C 19.847656 8.40625 19.410156 7.128906 18.757812 5.984375 C 18.300781 5.175781 17.738281 4.429688 17.109375 3.769531 C 16.964844 3.617188 16.816406 3.464844 16.65625 3.332031 C 16.457031 3.164062 16.191406 3.125 15.996094 3.332031 C 15.832031 3.507812 15.796875 3.863281 15.996094 4.035156 Z M 15.996094 4.035156 "/>
          <path style=" stroke:none;fill-rule:nonzero;fill:rgb(38.431373%,74.117647%,47.843137%);fill-opacity:1;" d="M 14.496094 15.339844 C 14.175781 16.472656 13.859375 17.605469 13.539062 18.742188 C 13.480469 18.945312 13.421875 19.152344 13.363281 19.359375 C 13.292969 19.621094 13.449219 19.902344 13.691406 19.972656 C 13.9375 20.042969 14.191406 19.882812 14.261719 19.625 C 14.582031 18.492188 14.902344 17.359375 15.21875 16.222656 C 15.277344 16.019531 15.335938 15.8125 15.394531 15.605469 C 15.46875 15.34375 15.308594 15.0625 15.070312 14.992188 C 14.820312 14.921875 14.566406 15.082031 14.496094 15.339844 Z M 14.496094 15.339844 "/>
          <path style=" stroke:none;fill-rule:nonzero;fill:rgb(38.431373%,74.117647%,47.843137%);fill-opacity:1;" d="M 4.019531 15.957031 C 3.679688 15.671875 3.378906 15.332031 3.09375 14.988281 C 2.949219 14.820312 2.816406 14.648438 2.683594 14.46875 C 2.667969 14.449219 2.648438 14.425781 2.632812 14.402344 C 2.746094 14.558594 2.671875 14.457031 2.644531 14.417969 C 2.609375 14.367188 2.570312 14.316406 2.535156 14.261719 C 2.460938 14.15625 2.390625 14.046875 2.324219 13.9375 C 2.015625 13.460938 1.75 12.953125 1.53125 12.425781 C 1.515625 12.390625 1.5 12.355469 1.488281 12.324219 C 1.457031 12.246094 1.539062 12.449219 1.507812 12.371094 C 1.5 12.355469 1.496094 12.339844 1.488281 12.320312 C 1.457031 12.246094 1.429688 12.171875 1.402344 12.09375 C 1.351562 11.945312 1.300781 11.792969 1.257812 11.640625 C 1.164062 11.328125 1.09375 11.007812 1.039062 10.683594 C 1.023438 10.605469 1.011719 10.523438 1.003906 10.441406 C 0.996094 10.402344 0.984375 10.316406 1.007812 10.492188 C 1.003906 10.472656 1.003906 10.453125 1 10.433594 C 0.996094 10.386719 0.992188 10.335938 0.984375 10.289062 C 0.96875 10.117188 0.957031 9.941406 0.953125 9.765625 C 0.941406 9.402344 0.960938 9.035156 1 8.675781 C 1.003906 8.636719 1.015625 8.542969 0.996094 8.714844 C 1 8.695312 1 8.671875 1.003906 8.648438 C 1.011719 8.601562 1.015625 8.558594 1.023438 8.511719 C 1.039062 8.414062 1.058594 8.3125 1.078125 8.214844 C 1.113281 8.019531 1.160156 7.824219 1.210938 7.632812 C 1.265625 7.433594 1.328125 7.234375 1.398438 7.039062 C 1.433594 6.941406 1.46875 6.84375 1.507812 6.746094 C 1.441406 6.910156 1.511719 6.734375 1.527344 6.695312 C 1.550781 6.640625 1.578125 6.582031 1.601562 6.523438 C 1.792969 6.09375 2.015625 5.675781 2.261719 5.277344 C 2.394531 5.058594 2.535156 4.847656 2.683594 4.636719 C 2.703125 4.613281 2.71875 4.585938 2.738281 4.5625 C 2.660156 4.671875 2.726562 4.578125 2.742188 4.558594 C 2.777344 4.507812 2.816406 4.453125 2.855469 4.402344 C 2.941406 4.289062 3.03125 4.175781 3.121094 4.066406 C 3.570312 3.507812 4.058594 2.992188 4.570312 2.503906 C 4.863281 2.222656 5.167969 1.957031 5.472656 1.695312 C 5.507812 1.667969 5.539062 1.640625 5.570312 1.613281 C 5.582031 1.601562 5.71875 1.492188 5.640625 1.554688 C 5.730469 1.480469 5.820312 1.410156 5.910156 1.339844 C 6.082031 1.199219 6.257812 1.0625 6.4375 0.929688 C 6.609375 0.796875 6.710938 0.597656 6.652344 0.367188 C 6.601562 0.167969 6.40625 -0.015625 6.203125 0.00390625 C 5.113281 0.101562 4.019531 0.203125 2.929688 0.300781 C 2.554688 0.335938 2.179688 0.371094 1.804688 0.40625 C 1.550781 0.425781 1.335938 0.613281 1.335938 0.902344 C 1.335938 1.15625 1.550781 1.421875 1.804688 1.398438 C 2.894531 1.296875 3.984375 1.199219 5.074219 1.097656 C 5.449219 1.066406 5.824219 1.03125 6.203125 0.996094 C 6.125 0.6875 6.042969 0.378906 5.964844 0.0703125 C 4.054688 1.515625 2.222656 3.246094 1.070312 5.453125 C 0.3125 6.910156 -0.101562 8.578125 0.0507812 10.25 C 0.167969 11.585938 0.605469 12.863281 1.257812 14.007812 C 1.714844 14.8125 2.277344 15.5625 2.90625 16.222656 C 3.050781 16.375 3.199219 16.527344 3.359375 16.660156 C 3.558594 16.828125 3.824219 16.867188 4.019531 16.660156 C 4.183594 16.484375 4.21875 16.128906 4.019531 15.957031 Z M 4.019531 15.957031 "/>
          <path style=" stroke:none;fill-rule:nonzero;fill:rgb(38.431373%,74.117647%,47.843137%);fill-opacity:1;" d="M 5.519531 4.652344 C 5.839844 3.519531 6.15625 2.382812 6.476562 1.25 C 6.535156 1.042969 6.59375 0.839844 6.652344 0.632812 C 6.722656 0.371094 6.566406 0.0898438 6.324219 0.0195312 C 6.078125 -0.0546875 5.824219 0.109375 5.753906 0.367188 C 5.433594 1.5 5.113281 2.632812 4.796875 3.765625 C 4.738281 3.972656 4.679688 4.179688 4.621094 4.386719 C 4.546875 4.644531 4.707031 4.925781 4.945312 5 C 5.195312 5.070312 5.449219 4.910156 5.519531 4.652344 Z M 5.519531 4.652344 "/>
          <path style=" stroke:none;fill-rule:nonzero;fill:rgb(38.431373%,74.117647%,47.843137%);fill-opacity:1;" d="M 10.007812 9.5 C 9.882812 9.496094 9.761719 9.488281 9.640625 9.472656 C 9.792969 9.492188 9.589844 9.460938 9.554688 9.453125 C 9.484375 9.4375 9.417969 9.421875 9.351562 9.402344 C 9.292969 9.382812 9.238281 9.363281 9.183594 9.34375 C 9.148438 9.332031 8.964844 9.25 9.101562 9.3125 C 8.984375 9.261719 8.871094 9.195312 8.765625 9.128906 C 8.714844 9.097656 8.664062 9.0625 8.617188 9.027344 C 8.59375 9.007812 8.570312 8.992188 8.546875 8.972656 C 8.464844 8.90625 8.628906 9.042969 8.550781 8.976562 C 8.449219 8.890625 8.359375 8.800781 8.273438 8.703125 C 8.230469 8.660156 8.191406 8.613281 8.15625 8.566406 C 8.136719 8.542969 8.117188 8.519531 8.101562 8.496094 C 8.035156 8.410156 8.164062 8.585938 8.101562 8.5 C 8.027344 8.390625 7.960938 8.277344 7.898438 8.160156 C 7.871094 8.105469 7.84375 8.050781 7.820312 7.992188 C 7.804688 7.964844 7.792969 7.9375 7.78125 7.90625 C 7.835938 8.039062 7.796875 7.9375 7.785156 7.910156 C 7.738281 7.78125 7.703125 7.652344 7.671875 7.519531 C 7.65625 7.457031 7.644531 7.394531 7.632812 7.328125 C 7.628906 7.300781 7.613281 7.183594 7.632812 7.335938 C 7.628906 7.300781 7.625 7.269531 7.625 7.238281 C 7.609375 7.09375 7.609375 6.953125 7.613281 6.808594 C 7.613281 6.742188 7.621094 6.679688 7.625 6.613281 C 7.628906 6.582031 7.644531 6.46875 7.625 6.617188 C 7.628906 6.585938 7.632812 6.550781 7.640625 6.519531 C 7.664062 6.386719 7.695312 6.25 7.734375 6.121094 C 7.753906 6.058594 7.773438 6 7.796875 5.941406 C 7.835938 5.839844 7.753906 6.046875 7.792969 5.945312 C 7.804688 5.917969 7.820312 5.890625 7.832031 5.859375 C 7.886719 5.738281 7.949219 5.621094 8.019531 5.511719 C 8.050781 5.457031 8.085938 5.40625 8.121094 5.359375 C 8.03125 5.484375 8.152344 5.320312 8.175781 5.292969 C 8.257812 5.191406 8.34375 5.09375 8.4375 5.007812 C 8.480469 4.964844 8.527344 4.925781 8.570312 4.886719 C 8.457031 4.984375 8.613281 4.859375 8.640625 4.839844 C 8.746094 4.761719 8.855469 4.695312 8.96875 4.632812 C 9 4.617188 9.179688 4.535156 9.042969 4.59375 C 9.097656 4.570312 9.152344 4.546875 9.210938 4.527344 C 9.332031 4.484375 9.457031 4.449219 9.585938 4.421875 C 9.613281 4.414062 9.644531 4.410156 9.671875 4.40625 C 9.78125 4.386719 9.5625 4.417969 9.667969 4.40625 C 9.730469 4.398438 9.792969 4.390625 9.851562 4.386719 C 9.988281 4.378906 10.121094 4.382812 10.253906 4.394531 C 10.285156 4.398438 10.316406 4.402344 10.347656 4.40625 C 10.453125 4.417969 10.234375 4.386719 10.34375 4.40625 C 10.402344 4.414062 10.460938 4.429688 10.519531 4.441406 C 10.644531 4.472656 10.769531 4.511719 10.890625 4.558594 C 10.917969 4.570312 10.945312 4.582031 10.972656 4.59375 C 10.847656 4.539062 10.941406 4.582031 10.96875 4.59375 C 11.019531 4.621094 11.074219 4.648438 11.125 4.675781 C 11.238281 4.742188 11.34375 4.8125 11.445312 4.890625 C 11.46875 4.90625 11.550781 4.976562 11.445312 4.886719 C 11.464844 4.90625 11.488281 4.925781 11.511719 4.945312 C 11.554688 4.984375 11.597656 5.027344 11.640625 5.070312 C 11.734375 5.160156 11.816406 5.257812 11.898438 5.363281 C 11.914062 5.382812 11.976562 5.472656 11.894531 5.359375 C 11.914062 5.382812 11.929688 5.410156 11.949219 5.433594 C 11.980469 5.484375 12.011719 5.535156 12.042969 5.589844 C 12.109375 5.703125 12.167969 5.824219 12.222656 5.945312 C 12.242188 5.996094 12.238281 5.984375 12.207031 5.914062 C 12.214844 5.933594 12.222656 5.953125 12.230469 5.972656 C 12.25 6.019531 12.265625 6.070312 12.28125 6.121094 C 12.3125 6.21875 12.335938 6.324219 12.359375 6.425781 C 12.367188 6.46875 12.375 6.511719 12.382812 6.550781 C 12.382812 6.574219 12.386719 6.59375 12.390625 6.617188 C 12.367188 6.46875 12.386719 6.582031 12.390625 6.613281 C 12.402344 6.722656 12.40625 6.832031 12.40625 6.941406 C 12.40625 7.210938 12.617188 7.4375 12.871094 7.4375 C 13.125 7.4375 13.339844 7.210938 13.339844 6.941406 C 13.332031 5.734375 12.757812 4.628906 11.820312 3.960938 C 11.355469 3.628906 10.808594 3.453125 10.253906 3.402344 C 9.6875 3.347656 9.121094 3.480469 8.605469 3.722656 C 7.632812 4.179688 6.90625 5.207031 6.730469 6.320312 C 6.546875 7.511719 6.917969 8.738281 7.757812 9.558594 C 8.371094 10.15625 9.175781 10.488281 10.007812 10.492188 C 10.261719 10.492188 10.472656 10.265625 10.472656 9.996094 C 10.472656 9.722656 10.261719 9.5 10.007812 9.5 Z M 10.007812 9.5 "/>
          <path style=" stroke:none;fill-rule:nonzero;fill:rgb(38.431373%,74.117647%,47.843137%);fill-opacity:1;" d="M 10.007812 10.5 C 10.132812 10.5 10.253906 10.507812 10.375 10.523438 C 10.222656 10.503906 10.425781 10.535156 10.460938 10.542969 C 10.53125 10.558594 10.597656 10.574219 10.664062 10.597656 C 10.722656 10.613281 10.777344 10.632812 10.832031 10.652344 C 10.867188 10.664062 11.050781 10.746094 10.914062 10.683594 C 11.03125 10.738281 11.144531 10.800781 11.25 10.867188 C 11.300781 10.902344 11.351562 10.933594 11.398438 10.96875 C 11.421875 10.988281 11.445312 11.003906 11.46875 11.023438 C 11.550781 11.089844 11.386719 10.953125 11.464844 11.019531 C 11.566406 11.105469 11.65625 11.195312 11.742188 11.292969 C 11.785156 11.335938 11.824219 11.382812 11.859375 11.429688 C 11.878906 11.453125 11.898438 11.476562 11.914062 11.5 C 11.980469 11.585938 11.851562 11.410156 11.914062 11.496094 C 11.988281 11.605469 12.054688 11.71875 12.117188 11.835938 C 12.144531 11.890625 12.171875 11.949219 12.195312 12.003906 C 12.210938 12.03125 12.222656 12.058594 12.234375 12.089844 C 12.179688 11.957031 12.21875 12.058594 12.230469 12.085938 C 12.277344 12.214844 12.316406 12.34375 12.34375 12.480469 C 12.359375 12.539062 12.371094 12.605469 12.382812 12.667969 C 12.386719 12.695312 12.402344 12.8125 12.382812 12.664062 C 12.386719 12.695312 12.390625 12.726562 12.390625 12.757812 C 12.40625 12.902344 12.410156 13.046875 12.402344 13.1875 C 12.402344 13.253906 12.394531 13.320312 12.390625 13.382812 C 12.386719 13.414062 12.371094 13.53125 12.390625 13.378906 C 12.386719 13.414062 12.382812 13.445312 12.375 13.476562 C 12.351562 13.613281 12.320312 13.746094 12.28125 13.875 C 12.261719 13.9375 12.242188 13.996094 12.21875 14.054688 C 12.179688 14.160156 12.261719 13.949219 12.222656 14.050781 C 12.210938 14.078125 12.195312 14.109375 12.183594 14.136719 C 12.128906 14.257812 12.066406 14.375 11.996094 14.488281 C 11.964844 14.539062 11.929688 14.589844 11.894531 14.636719 C 11.984375 14.511719 11.863281 14.675781 11.839844 14.707031 C 11.761719 14.808594 11.671875 14.902344 11.578125 14.992188 C 11.535156 15.03125 11.488281 15.070312 11.445312 15.109375 C 11.558594 15.011719 11.402344 15.136719 11.375 15.160156 C 11.269531 15.234375 11.160156 15.300781 11.046875 15.363281 C 11.015625 15.378906 10.835938 15.464844 10.972656 15.402344 C 10.917969 15.425781 10.863281 15.449219 10.804688 15.46875 C 10.683594 15.511719 10.558594 15.546875 10.433594 15.574219 C 10.402344 15.582031 10.371094 15.585938 10.34375 15.589844 C 10.234375 15.609375 10.453125 15.578125 10.347656 15.589844 C 10.285156 15.597656 10.222656 15.605469 10.164062 15.609375 C 10.027344 15.617188 9.894531 15.613281 9.761719 15.601562 C 9.730469 15.597656 9.699219 15.59375 9.667969 15.589844 C 9.5625 15.578125 9.78125 15.609375 9.671875 15.589844 C 9.613281 15.582031 9.554688 15.570312 9.496094 15.554688 C 9.371094 15.523438 9.246094 15.484375 9.125 15.4375 C 9.097656 15.425781 9.070312 15.414062 9.042969 15.402344 C 9.171875 15.457031 9.074219 15.414062 9.046875 15.402344 C 8.996094 15.375 8.941406 15.347656 8.890625 15.320312 C 8.78125 15.257812 8.671875 15.183594 8.570312 15.105469 C 8.546875 15.089844 8.464844 15.019531 8.570312 15.109375 C 8.550781 15.089844 8.527344 15.070312 8.503906 15.050781 C 8.460938 15.011719 8.417969 14.96875 8.375 14.929688 C 8.28125 14.835938 8.199219 14.738281 8.117188 14.636719 C 8.101562 14.613281 8.039062 14.523438 8.121094 14.636719 C 8.101562 14.613281 8.085938 14.589844 8.070312 14.5625 C 8.035156 14.511719 8.003906 14.460938 7.972656 14.410156 C 7.90625 14.292969 7.847656 14.171875 7.792969 14.050781 C 7.773438 14.003906 7.777344 14.011719 7.808594 14.082031 C 7.800781 14.0625 7.792969 14.042969 7.785156 14.023438 C 7.765625 13.976562 7.75 13.925781 7.734375 13.875 C 7.703125 13.777344 7.679688 13.671875 7.65625 13.570312 C 7.648438 13.527344 7.640625 13.488281 7.632812 13.445312 C 7.632812 13.421875 7.628906 13.402344 7.625 13.378906 C 7.648438 13.527344 7.628906 13.414062 7.625 13.382812 C 7.613281 13.273438 7.609375 13.164062 7.609375 13.054688 C 7.609375 12.785156 7.398438 12.558594 7.144531 12.558594 C 6.890625 12.558594 6.675781 12.785156 6.675781 13.054688 C 6.683594 14.261719 7.257812 15.367188 8.195312 16.035156 C 8.660156 16.367188 9.207031 16.542969 9.761719 16.59375 C 10.328125 16.652344 10.894531 16.519531 11.410156 16.273438 C 12.382812 15.816406 13.113281 14.789062 13.285156 13.675781 C 13.46875 12.488281 13.097656 11.257812 12.257812 10.4375 C 11.644531 9.839844 10.839844 9.507812 10.007812 9.503906 C 9.753906 9.503906 9.542969 9.730469 9.542969 10 C 9.542969 10.273438 9.753906 10.496094 10.007812 10.5 Z M 10.007812 10.5 "/>
          <path style=" stroke:none;fill-rule:nonzero;fill:rgb(38.431373%,74.117647%,47.843137%);fill-opacity:1;" d="M 9.535156 2.457031 C 9.535156 3.027344 9.535156 3.59375 9.535156 4.160156 C 9.535156 5.496094 9.535156 6.832031 9.535156 8.167969 C 9.535156 9.71875 9.535156 11.269531 9.535156 12.820312 C 9.535156 14.03125 9.535156 15.246094 9.535156 16.460938 C 9.535156 16.816406 9.535156 17.175781 9.535156 17.53125 C 9.535156 17.804688 9.746094 18.03125 10 18.03125 C 10.253906 18.03125 10.464844 17.804688 10.464844 17.53125 C 10.464844 16.964844 10.464844 16.398438 10.464844 15.828125 C 10.464844 14.496094 10.464844 13.160156 10.464844 11.824219 C 10.464844 10.273438 10.464844 8.722656 10.464844 7.171875 C 10.464844 5.960938 10.464844 4.746094 10.464844 3.53125 C 10.464844 3.175781 10.464844 2.816406 10.464844 2.457031 C 10.464844 2.1875 10.253906 1.960938 10 1.960938 C 9.746094 1.960938 9.535156 2.1875 9.535156 2.457031 Z M 9.535156 2.457031 "/>
        </g>
      </svg>
      </div>
    `
  }

  sellingPlanDropdown(group) {
    return html`
      <select
        class="selling-plan-dropdown ${this.getAvailableSellingPlans(group).length == 1 ? 'selling-plan-dropdown--one' : ''}"
        @change=${e => {
          this.selectSellingPlan(e.target.value)
        }}
      >
        ${group
          ? this.getAvailableSellingPlans(group).map(
              selling_plan => html` <option ?selected=${group.selected_selling_plan.id === selling_plan.id} value=${selling_plan.id}>${selling_plan.name}</option> `
            )
          : ''}
      </select>
    `
  }

  sellingPlanButtons(group) {
    return html`
      <fieldset class="selling-plan-buttons">
        <legend class="sr-only">Select subscription interval</legend>
        ${group
          ? this.getAvailableSellingPlans(group).map(
              selling_plan => html`
                <input
                  type="radio"
                  name="selling_plan_button"
                  value="${selling_plan}"
                  id="selling_plan_button-${selling_plan.id}"
                  @change="${e => this.selectSellingPlan(selling_plan.id)}"
                  ?checked=${group.selected_selling_plan === selling_plan}
                />

                <label for="selling_plan_button-${selling_plan.id}"> ${selling_plan.name} </label>
              `
            )
          : ''}
      </fieldset>
    `
  }

  invalidIcon() {
    return html`
      <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#D22B2B" class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    `
  }

  validIcon() {
    return html`
      <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#0BDA51" class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    `
  }

  setupMode() {
    return html`
      <div class="setupMode">
        Skio Plan Picker
        <small>This will not appear on the live site.</small>

        <small>Key: ${this.key}</small>

        <div class="detection">${this.product ? this.validIcon() : this.invalidIcon()} Product</div>

        <div class="detection">${this.selectedVariant ? this.validIcon() : this.invalidIcon()} Selected Variant</div>

        <div class="detection">${this.form ? this.validIcon() : this.invalidIcon()} Form</div>

        <div class="detection">${this.variantInput ? this.validIcon() : this.invalidIcon()} Variant Input</div>

        <div class="detection">
          ${this.variantChanged ? this.validIcon() : this.invalidIcon()} Variant Change Detection
          <small>Please attempt to change the selected variant.</small>
        </div>

        <small>If any of these don't pass please troubleshoot using our <a target="_blank" rel="noreferrer" href="https://integrate.skio.com/troubleshooting">troubleshooting guide</a>.</small>
      </div>
    `
  }

  groupContent(group) {
    return html`
      <div class="group-content ${this.options?.layout == 'horizontal' ? '' : this.options?.show_radio_selector && this.options?.dropdownPosition == 'inside' ? 'margin-left' : ''} ${this.selectedSellingPlan ? "" : 'd-none'}">
        <div class="every_delivery__bubble">
          DELIVERY EVERY
        </div>
        <span class="selling-plan-dropdown-label">${this.additionalFrequencyLabel()}</span>
        ${this.options?.selector_type == 'dropdown' ? this.sellingPlanDropdown(group) : ''}

        <!-- TODO: Make the label have the border instead of the group -->
        ${this.options?.selector_type == 'button' ? this.sellingPlanButtons(group) : ''} ${this.additionalContentText()}
      </div>
    `
  }

  // CUSTOM ATC PLACEMENT
atcRowTemplate() {
  const disabled =
    !this.selectedVariant ||
    this.selectedVariant?.available === false ||
    (this.product?.available === false);

  const cta = this.selectedSellingPlan
    ? (this.options?.atc_subscribe_text || 'GET STARTED')
    : (this.options?.atc_onetime_text || 'ADD TO CART');

  const qtyValue = String(this.getQuantity());

  const checkIcon = this.isResetProduct()
    ? 'https://cdn.shopify.com/s/files/1/2783/4656/files/icon_check-mark-purple.svg?v=1780592854'
    : 'https://cdn.shopify.com/s/files/1/2783/4656/files/icon_check-mark.svg?v=1763070155';

  // subscription / selling-plan case this.discount(group.selected_selling_plan)
  if (this.selectedSellingPlan) {
    console.log("SELLINGPLAN", this.selectedSellingPlan.options);
    return html`
      <div class="skio-atc-row" part="skio-atc-row">
        <div class="skio-qty">
          <button
            type="button"
            class="skio-qty__btn skio-qty__btn--minus"
            @click=${() => this.handleQtyStep(-1)}
            aria-label="Decrease quantity"
          >
            -
          </button>

          <input
            type="number"
            class="skio-qty__input"
            min="1"
            .value=${qtyValue}
            @change=${this.handleQtyInputChange}
            @input=${this.handleQtyInputChange}
          />

          <button
            type="button"
            class="skio-qty__btn skio-qty__btn--plus"
            @click=${() => this.handleQtyStep(1)}
            aria-label="Increase quantity"
          >
            +
          </button>
        </div>

        <button
          type="button"
          class="skio-atc-btn btn--primary"
          ?disabled=${disabled}
          @click=${this.handleAtcProxyClick}
        >
          ${cta}
        </button>
      </div>

      <div class="skio-points_main-container">
        <div class="skio-points_item-container">
          <img src="${checkIcon}" class="skio-points_item-img" />

          <span class="skio-points_item_content">
  ${
    this.selectedSellingPlan?.options?.[0]?.name === "Prepaid"
      ? "Gift & Get your own discount"
      : (this.product.id === 8476441018566
          ? "15% Off on future orders"
          : "15% Off on future orders"
        )
  }
</span>

        </div>
        <div class="skio-points_item-container">
          <img src="${checkIcon}" class="skio-points_item-img" />
          <span class="skio-points_item_content">Fast & free shipping forever</span>
        </div>
        <div class="skio-points_item-container">
          <img src="${checkIcon}" class="skio-points_item-img" />
          <span class="skio-points_item_content">Free gifts & surprises</span>
        </div>
        <div class="skio-points_item-container">
          <img src="${checkIcon}" class="skio-points_item-img" />
          <span class="skio-points_item_content">Pause, skip, or cancel anytime</span>
        </div>
      </div>
    `;
  }

  // one-time / default ATC when there is no selling plan
  return html`
    <div class="skio-atc-row" part="skio-atc-row">
      <div class="skio-qty">
        <button
          type="button"
          class="skio-qty__btn skio-qty__btn--minus"
          @click=${() => this.handleQtyStep(-1)}
          aria-label="Decrease quantity"
        >
          -
        </button>

        <input
          type="number"
          class="skio-qty__input"
          min="1"
          .value=${qtyValue}
          @change=${this.handleQtyInputChange}
          @input=${this.handleQtyInputChange}
        />

        <button
          type="button"
          class="skio-qty__btn skio-qty__btn--plus"
          @click=${() => this.handleQtyStep(1)}
          aria-label="Increase quantity"
        >
          +
        </button>
      </div>

      <button
        type="button"
        class="skio-atc-btn"
        ?disabled=${disabled}
        @click=${this.handleAtcProxyClick}
      >
        ${cta}
      </button>
    </div>
  `;
}

  showDetails() {
    return html`
      <details class="skio-details" @mouseover=${e => this.detailsMouseover()} @mouseleave=${e => this.detailsMouseleave()}>
        <summary>
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="ai ai-ArrowRepeat"
            >
              <path d="M18 2l3 3-3 3" />
              <path d="M6 22l-3-3 3-3" />
              <path d="M21 5H10a7 7 0 0 0-7 7" />
              <path d="M3 19h11a7 7 0 0 0 7-7" />
            </svg>

            How do subscriptions work?
          </span>
        </summary>
        <div class="skio-details--content">
          <ul>
            <li>
              <div class="skio-icon">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
                  />
                </svg>
              </div>
              <div class="skio-content">
                <p>Get exclusive deals</p>
                <small>Subscribe for unique discounts</small>
              </div>
            </li>
            <li>
              <div class="skio-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                </svg>
              </div>
              <div class="skio-content">
                <p>Edit your subscription anytime</p>
                <small>Edit products, delivery schedule and more</small>
              </div>
            </li>
            <li>
              <div class="skio-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path
                    fill-rule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>

              <div class="skio-content">
                <p>No commitment</p>
                <small>Easy to cancel if it’s not for you</small>
              </div>
            </li>
          </ul>
          <div class="skio-details--footer">
            <a class="skio-manage-link" href="/a/account/login">Manage subscriptions</a>

            <a style="letter-spacing: 0" class="powered-by-skio" href="https://skio.com/?utm_source=eonsincshop.myshopify.com&utm_medium=details_popover" target="_blank" rel="noopener">
              Powered by
              <svg width="24" height="11" viewBox="0 0 24 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4.28399 5.78801C4.12399 5.63601 3.93599 5.50801 3.71999 5.40401C3.50399 5.30001 3.27599 5.24801 3.03599 5.24801C2.85199 5.24801 2.67999 5.28401 2.51999 5.35601C2.36799 5.42801 2.29199 5.55201 2.29199 5.72801C2.29199 5.89601 2.37599 6.01601 2.54399 6.08801C2.71999 6.16001 2.99999 6.24001 3.38399 6.32801C3.60799 6.37601 3.83199 6.44401 4.05599 6.53201C4.28799 6.62001 4.49599 6.73601 4.67999 6.88001C4.86399 7.02401 5.01199 7.20001 5.12399 7.40801C5.23599 7.61601 5.29199 7.86401 5.29199 8.15201C5.29199 8.52801 5.21599 8.84801 5.06399 9.11201C4.91199 9.36801 4.71199 9.57601 4.46399 9.73601C4.22399 9.89601 3.95199 10.012 3.64799 10.084C3.34399 10.156 3.03999 10.192 2.73599 10.192C2.24799 10.192 1.76799 10.116 1.29599 9.96401C0.831989 9.80401 0.443989 9.57201 0.131989 9.26801L1.23599 8.10401C1.41199 8.29601 1.62799 8.45601 1.88399 8.58401C2.13999 8.71201 2.41199 8.77601 2.69999 8.77601C2.85999 8.77601 3.01599 8.74001 3.16799 8.66801C3.32799 8.58801 3.40799 8.45201 3.40799 8.26001C3.40799 8.07601 3.31199 7.94001 3.11999 7.85201C2.92799 7.76401 2.62799 7.67201 2.21999 7.57601C2.01199 7.52801 1.80399 7.46401 1.59599 7.38401C1.38799 7.30401 1.19999 7.19601 1.03199 7.06001C0.871989 6.92401 0.739989 6.75601 0.635989 6.55601C0.531989 6.35601 0.479989 6.11601 0.479989 5.83601C0.479989 5.47601 0.555989 5.17201 0.707989 4.92401C0.859989 4.66801 1.05599 4.46001 1.29599 4.30001C1.53599 4.14001 1.79999 4.02401 2.08799 3.95201C2.38399 3.87201 2.67599 3.83201 2.96399 3.83201C3.41199 3.83201 3.84799 3.90401 4.27199 4.04801C4.70399 4.18401 5.06799 4.39201 5.36399 4.67201L4.28399 5.78801Z"
                  fill="black"
                />
                <path d="M12.8481 10H10.4121L8.45615 7.13201H8.42015V10H6.44015V0.928009H8.42015V6.44801H8.45615L10.3641 4.02401H12.7521L10.4481 6.72401L12.8481 10Z" fill="black" />
                <path
                  d="M15.7009 2.11601C15.7009 2.26801 15.6689 2.41201 15.6049 2.54801C15.5489 2.67601 15.4689 2.78801 15.3649 2.88401C15.2689 2.98001 15.1489 3.05601 15.0049 3.11201C14.8689 3.16801 14.7249 3.19601 14.5729 3.19601C14.2529 3.19601 13.9849 3.09201 13.7689 2.88401C13.5529 2.66801 13.4449 2.41201 13.4449 2.11601C13.4449 1.97201 13.4729 1.83601 13.5289 1.70801C13.5849 1.57201 13.6649 1.45601 13.7689 1.36001C13.8729 1.26401 13.9929 1.18801 14.1289 1.13201C14.2649 1.06801 14.4129 1.03601 14.5729 1.03601C14.7249 1.03601 14.8689 1.06401 15.0049 1.12001C15.1489 1.17601 15.2689 1.25201 15.3649 1.34801C15.4689 1.44401 15.5489 1.56001 15.6049 1.69601C15.6689 1.82401 15.7009 1.96401 15.7009 2.11601ZM13.5889 10V4.02401H15.5569V10H13.5889Z"
                  fill="black"
                />
                <path
                  d="M23.4516 6.98801C23.4516 7.47601 23.3636 7.92001 23.1876 8.32001C23.0116 8.71201 22.7716 9.04801 22.4676 9.32801C22.1636 9.60001 21.8116 9.81201 21.4116 9.96401C21.0116 10.116 20.5836 10.192 20.1276 10.192C19.6796 10.192 19.2516 10.116 18.8436 9.96401C18.4436 9.81201 18.0916 9.60001 17.7876 9.32801C17.4916 9.04801 17.2556 8.71201 17.0796 8.32001C16.9036 7.92001 16.8156 7.47601 16.8156 6.98801C16.8156 6.50001 16.9036 6.06001 17.0796 5.66801C17.2556 5.27601 17.4916 4.94401 17.7876 4.67201C18.0916 4.40001 18.4436 4.19201 18.8436 4.04801C19.2516 3.90401 19.6796 3.83201 20.1276 3.83201C20.5836 3.83201 21.0116 3.90401 21.4116 4.04801C21.8116 4.19201 22.1636 4.40001 22.4676 4.67201C22.7716 4.94401 23.0116 5.27601 23.1876 5.66801C23.3636 6.06001 23.4516 6.50001 23.4516 6.98801ZM21.5556 6.98801C21.5556 6.79601 21.5236 6.60801 21.4596 6.42401C21.3956 6.24001 21.3036 6.08001 21.1836 5.94401C21.0636 5.80001 20.9156 5.68401 20.7396 5.59601C20.5636 5.50801 20.3596 5.46401 20.1276 5.46401C19.8956 5.46401 19.6916 5.50801 19.5156 5.59601C19.3396 5.68401 19.1916 5.80001 19.0716 5.94401C18.9596 6.08001 18.8716 6.24001 18.8076 6.42401C18.7516 6.60801 18.7236 6.79601 18.7236 6.98801C18.7236 7.18001 18.7516 7.36801 18.8076 7.55201C18.8716 7.73601 18.9636 7.90401 19.0836 8.05601C19.2036 8.20001 19.3516 8.31601 19.5276 8.40401C19.7036 8.49201 19.9076 8.53601 20.1396 8.53601C20.3716 8.53601 20.5756 8.49201 20.7516 8.40401C20.9276 8.31601 21.0756 8.20001 21.1956 8.05601C21.3156 7.90401 21.4036 7.73601 21.4596 7.55201C21.5236 7.36801 21.5556 7.18001 21.5556 6.98801Z"
                  fill="black"
                />
              </svg>
            </a>
          </div>
        </div>
      </details>
    `
  }

  // !SECTION: Element Templates

  render() {
    if (!this.viable() || this.options?.layout === 'hidden') {
      return this.debug ? this.setupMode() : ''
    }

    // @FINDME COMENTED OUT - BREAKING VARIANTS WITH NO SUBSCRIPTION PLANS
    //if (this.selectedVariant.selling_plan_allocations.length === 0 && !this.options?.show_without_subscription) {
    //  return this.debug ? this.setupMode() : ''
    // CHANGEME - hard coding values for prepaid plans
    //}

    return html`
      ${this.debug ? this.setupMode() : null}

      <fieldset class="skio-plan-picker" role="radiogroup" aria-labelledby="skio-plan-picker-legend">
        <legend id="skio-plan-picker-legend" class="${!this.options?.show_legend ? 'sr-only' : ''}">${unsafeHTML(this.options?.legend_content)}</legend>

${!this.product.requires_selling_plan && this.availableSellingPlanGroups?.length == 0
          ? html`
              <div
                class="group-container ${this.selectedSellingPlanGroup == null ? 'group-container--selected' : ''} ${!this.options?.onetime_first ? 'group-container--last' : ''}"
                @click=${() => this.selectSellingPlanGroup(null)}
              >
                <input
                  id="one-time-${this.key}"
                  class="group-input"
                  name="skio-group-${this.key}"
                  type="radio"
                  value="One-Time Purchase"
                  ?checked=${!this.selectedSellingPlanGroup}
                  @change=${() => this.selectSellingPlanGroup(null)}
                />

                  ${String(this.selectedVariant?.id) === '44577230028998'
                    ? html`
                      <span class="discount_badge mobile border-fix ${this.isResetProduct() ? 'reset-badge' : ''}">Get 20% OFF</span>
                    `
                  : null}


                <label class="group-label" for="one-time-${this.key}">
                  <div class="group-topline">
                    ${this.options?.layout == 'horizontal' ? '' : this.options?.show_radio_selector ? this.radioTemplate() : ''}

                    <div class="group-title one-time-group">${this.options?.onetime_title ? this.options?.onetime_title : 'One-Time Purchase'}</div>

                    <div class="skio-price one-time__price_text" aria-live="polite" >
                      ${this.options?.show_compare_price && this.selectedVariant?.compare_at_price > this.selectedVariant.price
                        ? html`<s aria-hidden="true">${this.money(this.selectedVariant.compare_at_price)}</s>`
                        : ''}
                      ${this.money(this.selectedVariant.price)}
                    </div>
                  </div>
                ${this.selectedSellingPlanGroup == null ? this.atcRowTemplate() : ''}
                </label>
              </div>
            `
          : ''}

        ${this.availableSellingPlanGroups?.length
          ? this.availableSellingPlanGroups.map(
              (group, index) => html`
              ${(console.log("groupHere",group.name))}

              ${!this.product.requires_selling_plan && group.name !== "Prepaid"
          ? html`
              <div
                class="group-container prepaid-test-2 ${this.selectedSellingPlanGroup == null ? 'group-container--selected' : ''} ${!this.options?.onetime_first ? 'group-container--last' : ''}"
                @click=${() => this.selectSellingPlanGroup(null)}
              >
                <input
                  id="one-time-${this.key}"
                  class="group-input"
                  name="skio-group-${this.key}"
                  type="radio"
                  value="One-Time Purchase"
                  ?checked=${!this.selectedSellingPlanGroup}
                  @change=${() => this.selectSellingPlanGroup(null)}
                />

                <label class="group-label" for="one-time-${this.key}">
                  <div class="group-topline">
                    ${this.options?.layout == 'horizontal' ? '' : this.options?.show_radio_selector ? this.radioTemplate() : ''}

                    <div class="group-title one-time-group"> ${this.options?.onetime_title ? this.options?.onetime_title : 'One-Time Purchase'} </div>

                    <div class="skio-price one-time__price_text" aria-live="polite">
                      ${this.options?.show_compare_price && this.selectedVariant?.compare_at_price > this.selectedVariant.price
                        ? html`<s aria-hidden="true">${this.money(this.selectedVariant.compare_at_price)}</s>`
                        : ''}
                        ${this.money(this.selectedVariant.price)}
                    </div>
                  </div>
                ${this.selectedSellingPlanGroup == null ? this.atcRowTemplate() : ''}
                </label>
              </div>
            `
          : ''}


                <div class="skio-subscription__top-header ${ group.name }">
                  <p class="select_frequency">SELECT FREQUENCY:</p>
                  <p class="learn_more__button">Learn More</p>
                </div>
                <div class="group-container ${group.name == 'Prepaid' ? 'prepaid-container group-container--last' : 'subscription-container'} ${this.selectedSellingPlanGroup == group ? 'group-container--selected' : ''} ${this.selectedSellingPlanGroup == group ? 'border-fix' : ''}">
                <span class="discount_badge mobile ${this.selectedSellingPlanGroup == group ? 'border-fix' : ''} ${this.isResetProduct() ? 'reset-badge' : ''}">
                  Get
                  ${
                    group.name === 'Prepaid'
                      ? ['\$20 BACK', '\$40 BACK', '\$75 BACK'][
                          this.getAvailableSellingPlans(group)
                            .findIndex(plan => plan.id == group.selected_selling_plan?.id)
                        ] || '$20 Back'
                      : `${this.discount(group.selected_selling_plan)?.percent}% OFF`
                  }
                </span>

                  <input
                    id="group-${index}-${this.key}"
                    class="group-input"
                    name="skio-group-${this.key}"
                    type="radio"
                    value="${group.id}"
                    @change=${() => this.selectSellingPlanGroup(group)}
                    ?checked=${this.selectedSellingPlanGroup == group}
                  />

                  <label class="group-label" for="group-${index}-${this.key}">
                    <div class="group-topline">
                      ${this.options?.layout == 'horizontal' ? '' : this.options?.show_radio_selector ? this.radioTemplate() : ''}

                      <div class="group-title subscription-group">
                        ${group.name !== 'Prepaid' && this.options?.subscription_title
                          ? this.options?.subscription_title
                          : group.name == 'Prepaid' && this.options?.prepaid_title
                          ? "Gift  a Subscription"
                          : group.name}
                        <span class="discount_badge desktop ${this.isResetProduct() ? 'reset-badge' : ''}">
                          Get
                          ${
                            group.name === 'Prepaid'
                              ? ['\$20 BACK', '\$40 BACK', '\$75 BACK'][
                                  this.getAvailableSellingPlans(group)
                                    .findIndex(plan => plan.id == group.selected_selling_plan?.id)
                                ] || '$20 Back'
                              : `${this.discount(group.selected_selling_plan)?.percent}% OFF`
                          }
                        </span>
                        <span>${group.selectedSellingPlan}</span>
                      </div>

                      <div class="skio-price" aria-live="polite">
                        ${this.options?.show_compare_price &&
                        (this.selectedVariant?.compare_at_price > this.selectedVariant.price || this.selectedVariant.price > this.price(group.selected_selling_plan, false))
                          ? html`<s aria-hidden="true">${this.money(this.selectedVariant.compare_at_price ? this.selectedVariant.compare_at_price : this.selectedVariant.price)}</s>`
                          : ''}
                        <span class="selected_plan__price">${this.price(group.selected_selling_plan)}</span>
                      </div>
                    </div>

                    <div class="subscription_savings">
                      <div class="skio-savings">
                        ${this.discountText(group.selected_selling_plan)
                          ? html`<span>${group.name == 'Prepaid' ? 'Pay up front and lock in' : 'Lock in'} </span> <span class="savings ${this.options?.discount_style}"> ${this.discountText(group.selected_selling_plan)} ${group.name=='Prepaid' ? 'off' : ''}</span> ${group.selected_selling_plan?.options?.[0]?.name=='Prepaid'? '': html`<span> and never run out</span>`}`
                          : html``}
                      </div>
                    </div>

                    ${this.options?.layout == 'vertical' && this.options?.dropdownPosition == 'inside' ? this.groupContent(group) : ''}
                    ${this.selectedSellingPlanGroup == group ? this.atcRowTemplate() : ''}
                  </label>
                </div>
                ${this.selectedSellingPlanGroup == group ? (this.options?.layout == 'horizontal' || this.options?.dropdownPosition == 'underneath' ? this.groupContent(group) : '') : ''}

          ${!this.product.requires_selling_plan && group.name === "Prepaid"
          ? html`
              <div
                class="group-container prepaid-test ${this.selectedSellingPlanGroup == null ? 'group-container--selected' : ''} ${!this.options?.onetime_first ? 'group-container--last' : ''}"
                @click=${() => this.selectSellingPlanGroup(null)}
              >
                <input
                  id="one-time-${this.key}"
                  class="group-input"
                  name="skio-group-${this.key}"
                  type="radio"
                  value="One-Time Purchase"
                  ?checked=${!this.selectedSellingPlanGroup}
                  @change=${() => this.selectSellingPlanGroup(null)}
                />

                <label class="group-label" for="one-time-${this.key}">
                  <div class="group-topline">
                    ${this.options?.layout == 'horizontal' ? '' : this.options?.show_radio_selector ? this.radioTemplate() : ''}

                    <div class="group-title">${this.options?.onetime_title ? this.options?.onetime_title : 'One-Time Purchase'}</div>
                    <div class="skio-price one-time__price_text" aria-live="polite">
                      ${this.options?.show_compare_price && this.selectedVariant?.compare_at_price > this.selectedVariant.price
                        ? html`<s aria-hidden="true">${this.money(this.selectedVariant.compare_at_price)}</s>`
                        : ''}
                      ${this.money(this.selectedVariant.price)}
                    </div>
                  </div>
                ${this.selectedSellingPlanGroup == null ? this.atcRowTemplate() : ''}
                </label>
              </div>


            `
          : ''}
              `
            )

          : ''}

        ${this.options?.show_details == true ? this.showDetails() : ''}
      </fieldset>
    `
  }

  async fetchRules() {
    if (sessionStorage.getItem('skio-discount-rules')) {
      return JSON.parse(sessionStorage.getItem('skio-discount-rules'))
    } else {
      const rules = await fetch(`https://api.skio.com/storefront-http/get-rules-by-domain-or-hostname?domain=${window?.Shopify?.shop}`)
        .then(response => response.json())
        .then(response => {
          return response.rules.filter(rule => rule.type !== 'surpriseDelight').sort((a, b) => a.minQuantityToDiscount - b.minQuantityToDiscount)
        })

      sessionStorage.setItem('skio-discount-rules', JSON.stringify(rules))
      return rules
    }
  }

  eligibleItemCount(rule) {
    if (!this.cart?.items) return this.quantity

    let cartItems = Number(
      this.cart?.items.reduce((aggregate, item) => (rule?.productVariantIds.some(gid => gid.includes(item.id) && item.selling_plan_allocation) ? aggregate + item.quantity : aggregate), 0)
    )

    return cartItems + this.quantity
  }

  getRule() {
    let largestMinQuantity = {
      value: -1,
      index: -1,
    }

    this.rules.forEach((rule, index) => {
      if (rule.code && largestMinQuantity.value < rule.minQuantityToDiscount) {
        if (rule.minQuantityToDiscount <= this.eligibleItemCount(rule)) {
          largestMinQuantity.value = rule.minQuantityToDiscount
          largestMinQuantity.index = index
        }
      }
    })

    this.rule = largestMinQuantity.index > -1 ? this.rules[largestMinQuantity.index] : null
  }

  bindCartEvents() {
    document.addEventListener('CartUpdated', event => {
      this.cart = event.detail
    })
  }

  bindFormEvents() {
    this.form = document.querySelector(`#${this.options?.form_id}`) || this.closest('form[action*="/cart/add"]')
    if (!this.form) {
      return
    }

    this.variantInput = this.form.querySelector('[name="id"]')

    if (this.variantInput) {
      this.variantInput.addEventListener('change', e => {
        this.selectedVariant = this.product.variants.find(variant => variant.id == e.target.value)
        this.variantChanged = true
      })
    }
  }

  detailsMouseover() {
    let details = this.renderRoot.querySelector('.skio-details')
    let summary = this.renderRoot.querySelector('.skio-details summary')
    if (!details.hasAttribute('open') && this.showDetailsHover == false) {
      summary.click()
      this.showDetailsHover = true
    }
  }

  detailsMouseleave() {
    let details = this.renderRoot.querySelector('.skio-details')
    let summary = this.renderRoot.querySelector('.skio-details summary')
    if (details.hasAttribute('open') && this.showDetailsHover == true) {
      summary.click()
      this.showDetailsHover = false
    }
  }

  updated(changed) {
  this.hideNativeATC(true);

  // Reset products: swap the selected-state accent color to purple
  if (this.isResetProduct()) {
    this.style.setProperty('--skio-group-border-selected-color', '#6c28f3');
  } else {
    this.style.removeProperty('--skio-group-border-selected-color');
  }

  if (!this.viable()) return;

  if (changed.has('product') && this.product) {
    this.key = this.key ? this.key : this.product.id;
  }

  if (changed.has('selectedVariant') && this.selectedVariant) {
    // NEW: track whether the *previous* variant had any selling plan groups
    const hadPlansBefore = !!(this.availableSellingPlanGroups && this.availableSellingPlanGroups.length);

    const filteredSellingPlanGroups = this.product.selling_plan_groups.filter(
      selling_plan_group =>
        selling_plan_group.app_id === 'SKIO' &&
        !selling_plan_group.name.toLowerCase().includes('hidden-') &&
        !selling_plan_group.name.toLowerCase().includes('dynamic box subscription')
    );

    // update availableSellingPlanGroups based on skioSellingPlanGroups and selectedVariant.id
    this.availableSellingPlanGroups = filteredSellingPlanGroups.filter(selling_plan_group =>
      selling_plan_group.selling_plans.some(selling_plan =>
        this.selectedVariant.selling_plan_allocations.some(
          selling_plan_allocation => selling_plan_allocation.selling_plan_id === selling_plan.id
        )
      )
    );

    if (this.options?.combine_groups) {
      this.availableSellingPlanGroups = [
        {
          name: this.options?.combined_group_name,
          selling_plans: this.availableSellingPlanGroups.flatMap(group => group.selling_plans),
          id: 'combined_group',
          app_id: 'SKIO',
        },
      ];
    }

    const hasPlansNow = !!(this.availableSellingPlanGroups && this.availableSellingPlanGroups.length);
    const newlyGainedPlans = !hadPlansBefore && hasPlansNow; // ← key case for your bug

    if (hasPlansNow) {
      const url = new URL(window.location.href);
      const urlSelectedSellingPlanId = url.searchParams.get('selling_plan');

      // update each group with a default selected_selling_plan
      this.availableSellingPlanGroups.forEach(group => {
        const availableSellingPlans = this.getAvailableSellingPlans(group);

        const urlSelectedSellingPlan = availableSellingPlans.find(plan => plan.id == urlSelectedSellingPlanId);
        const nameSelectedSellingPlan = availableSellingPlans.find(
          plan => plan.name === this.selectedSellingPlan?.name
        );
        const defaultSellingPlan =
          this.options?.default_subscription && this.options.default_subscription.trim() !== ''
            ? availableSellingPlans.find(plan =>
                plan.name.toLowerCase().includes(this.options.default_subscription.toLowerCase())
              )
            : null;

        group.selected_selling_plan =
          urlSelectedSellingPlan || nameSelectedSellingPlan || defaultSellingPlan || availableSellingPlans[0];

        const isAnyPlanSelected = urlSelectedSellingPlan || nameSelectedSellingPlan || defaultSellingPlan;
        group.selected = !!isAnyPlanSelected;
      });

      // UPDATED CONDITION:
      // - original logic
      // - PLUS: if we *just regained* selling plans (variant with no plans -> variant with plans),
      //   auto-select a selling plan instead of falling back to one-time.
      if (
        (!this.variantChanged && this.options?.start_onetime == false) ||
        this.product.requires_selling_plan == true ||
        urlSelectedSellingPlanId ||
        this.selectedSellingPlan ||
        newlyGainedPlans // 👈 this is what fixes your case
      ) {
        let selectedSellingPlanGroup =
          this.availableSellingPlanGroups.find(group => group.selected) || this.availableSellingPlanGroups[0];
        let selectedSellingPlanId = selectedSellingPlanGroup.selected_selling_plan.id;
        this.selectSellingPlan(selectedSellingPlanId);
      } else {
        this.selectSellingPlanGroup(null);
      }
    } else {
      // no selling plans for this variant → one-time only
      this.selectSellingPlanGroup(null);
    }
  }

  if (changed.has('selectedSellingPlan')) {
    //dispatch CustomEvent to tell that this specific plan picker was updated, and pass the selectedSellingPlan
    const event = new CustomEvent(`skio::update-selling-plan`, {
      bubbles: true,
      composed: true,
      detail: {
        variant: this.selectedVariant,
        sellingPlan: this.selectedSellingPlan,
        key: this.key,
      },
    });

    this.dispatchEvent(event);

    this.dispatchEvent(
      new CustomEvent('change', {
        detail: { value: this.selectedSellingPlan?.id },
      })
    );
  }

  this.updateForm();
  this.updateExternalPrice();

  if (!this.disableUrl) {
    this.updateURLParams();
  }

  if (changed.has('quantity')) {
    this.getRule();
  }

  if (changed.has('cart')) {
    this.getRule();
  }

  this.updateExternalElements();
}


  updateExternalElements() {
    document.querySelectorAll(`[skio-price][skio-key="${this.key}"]`).forEach(el => {
      el.innerHTML = this.price(this.selectedSellingPlan)
    })

    document.querySelectorAll(`[skio-subscription-content]`).forEach(el => {
      el.style.display = this.selectedSellingPlan ? 'block' : 'none'
    })
  }

  // SECTION: Utility Functions
  log(...args) {
    args.unshift(`%c[skio plan picker][${this.key}]`, 'color: #8770f2;')
    console.log.apply(console, args)
  }

  error(...args) {
    args.unshift(`%c [skio plan picker][${this.key}]`, 'color: #ff0000')
    console.error.apply(console, args)
  }

  appendOrdinalSuffix(num) {
    const j = num % 10,
      k = num % 100
    if (j == 1 && k != 11) {
      return num + 'st'
    }
    if (j == 2 && k != 12) {
      return num + 'nd'
    }
    if (j == 3 && k != 13) {
      return num + 'rd'
    }
    return num + 'th'
  }

  money(price) {
    return this.moneyFormatter.format(price / 100.0)
  }

  viable() {
    const errors = []

    const sellingPlanInput = this.querySelector('input[name=selling_plan]')
    if (!sellingPlanInput) {
      errors.push('Missing selling plan input')
    }

    if (!this.product) {
      errors.push('No product found. Please pass a product or productHandle to the skio-plan-picker component.')
    }
    if (!this.selectedVariant) {
      errors.push('No variant found. Please pass a product or productHandle to the skio-plan-picker component.')
    }
    if (!this.form) {
      errors.push('No form found. Please add a form_id to the plan picker through the Shopify customizer or ensure that the element is in a form that has an input with name="id".')
    }
    if (!this.variantInput) {
      errors.push('No variant input found. Please add a form_id to the plan picker through the Shopify customizer or ensure that the element is in a form that has an input with name="id"')
    }

    if (errors.length == 0) return true

    this.error('Errors', errors)
    return false
  }

  getAvailableSellingPlans(group) {
    let availableSellingPlans = group.selling_plans.filter(selling_plan =>
      this.selectedVariant.selling_plan_allocations.some(selling_plan_allocation => selling_plan_allocation.selling_plan_id === selling_plan.id)
    )
    return availableSellingPlans
  }

  // !SECTION: Utility Functions

  // Update selected selling plan group; called on click of group-container element
  selectSellingPlanGroup(group) {
    this.selectedSellingPlanGroup = group
    this.selectedSellingPlan = group?.selected_selling_plan
  }

  // Update selected selling plan; called on change of skio-frequency select element
  selectSellingPlan(selling_plan_id) {
    const selectedGroup = this.availableSellingPlanGroups.find(group => group.selling_plans.some(plan => plan.id == selling_plan_id))
    const selectedSellingPlan = selectedGroup.selling_plans.find(plan => plan.id == selling_plan_id)

    selectedGroup.selected_selling_plan = selectedSellingPlan
    this.selectedSellingPlanGroup = selectedGroup
    this.selectedSellingPlan = selectedSellingPlan
  }

  updateExternalPrice() {
    document.querySelectorAll(this.options?.external_price_selector).forEach(el => {
      this.selectedSellingPlan ? (el.innerHTML = this.price(this.selectedSellingPlan)) : (el.innerHTML = this.money(this.selectedVariant.price))
    })
    document.querySelectorAll(this.options?.external_price_selector).forEach(el => {
      this.selectedSellingPlan ? (el.innerHTML = this.price(this.selectedSellingPlan) + ' ' + this.currency) : (el.innerHTML = this.money(this.selectedVariant.price) + ' ' + this.currency)
    })
  }

  additionalFrequencyLabel() {
    if (!this.options?.additional_frequency_label || this.options?.additional_frequency_label == '') return

    return unsafeHTML(this.options?.additional_frequency_label)
  }

  additionalContentText() {
    if (!this.options?.additional_subscription_content || this.options?.additional_subscription_content == '') return

    return unsafeHTML(
      this.options?.additional_subscription_content
        .replaceAll('[discount]', this.options?.discount_format === 'absolute' ? this.money(this.discount(this.selectedSellingPlan).absolute) : this.discount(this.selectedSellingPlan).percent + '%')
        .replaceAll('[future_price_adjustments]', this.postCheckoutDiscountsText(this.selectedSellingPlan) || '')
    )
  }

  // SECTION: Discount Functions
  // Calculates discount based on selling_plan.price_adjustments, returns { percent, amount } of selling plan discount
  discountText(selling_plan) {
    const discount = this.discount(selling_plan)
    const hasInvalidDiscount = Object.values(discount).some(value => value === 0 || value === Infinity || value.toString().includes('-'))

    return unsafeHTML(
      this.options?.discount_text
        .replaceAll('[discount]', this.options?.discount_format === 'absolute' ? this.money(discount.absolute) : discount.percent + '%')
        .replaceAll('[future_price_adjustments]', this.postCheckoutDiscountsText(selling_plan) || '').replaceAll(/Save\s+/g, "")
    )
  }

  discount(selling_plan) {
    if (!selling_plan) return { percent: 0, amount: 0 }
    return this.getDiscountFromPriceAdjustment(selling_plan, selling_plan.price_adjustments[0])
  }

  postCheckoutPriceAdjustments(selling_plan) {
    const { price_adjustments } = selling_plan
    const postCheckoutPriceAdjustments = price_adjustments.filter(({ position }) => position !== 1)
    const discounts = postCheckoutPriceAdjustments.map(price_adjustment => this.getDiscountFromPriceAdjustment(selling_plan, price_adjustment))
    return discounts
  }

  postCheckoutDiscountsText(sellingPlan = this.selectedSellingPlan) {
    if (!sellingPlan || !this.options?.future_price_adjustments_text || this.future_price_adjustments_text == '') return

    const postCheckoutPriceAdjustments = this.postCheckoutPriceAdjustments(sellingPlan)
    if (!postCheckoutPriceAdjustments.length) return

    return postCheckoutPriceAdjustments.map((discount, index) =>
      this.options?.future_price_adjustments_text
        .replaceAll('[discount]', this.options?.discount_format === 'absolute' ? this.money(discount.absolute) : discount.percent + '%')
        .replaceAll('[order_count]', index + 1)
        .replaceAll('[order_count_ordinal]', this.appendOrdinalSuffix(index + 1))
    )
  }

  getTotalTime(str) {
    const regex = /(\d+) boxes.*\((\d+) delivered every (\d+) (days|weeks|months)\)/;

    const match = str.match(regex);
    const boxes = match ? parseInt(match[1], 10) : 0;
    const frequency = match ? parseInt(match[3], 10) : 0;
    const unit = match ? match[4] : '';

    let totalTime;
    switch (unit) {
        case 'days':
            totalTime = boxes * frequency;
            break;
        case 'weeks':
            totalTime = boxes * frequency * 7;
            break;
        case 'months':
            totalTime = boxes * frequency * 30;
            break;
        default:
            totalTime = 0;
        }
    return parseInt(totalTime);
  }

  calculateTotalDuration(input, hasUnit) {
    const match = input.match(/(\d+) boxes.*?1 delivered every (\d+) (weeks|days|months)/);

    if (match) {
      const boxes = parseInt(match[1], 10);
      const interval = parseInt(match[2], 10);
      const unit = match[3]; // Extract the time unit (weeks, days, months)

      // Calculate total based on the unit
      let total;
      switch (unit) {
        case 'weeks':
          total = hasUnit ? "off for " + boxes * interval + " weeks" : boxes;
          break;
        case 'days':
          total = hasUnit ? "off for " + boxes * interval + " days" : boxes;
          break;
        case 'months':
          total = hasUnit ? "off for " + boxes * interval + " months" : boxes;
          break;
        default:
          total = null; // Fallback for unexpected units
      }
      return hasUnit ? total : parseInt(total);
    }
    return null;
  }

  getPrepayDiscountPercent(price, totalduration, discountPrice) {
    const discountPercent = ((price * totalduration) - discountPrice) / (price * totalduration) * 100;
    return discountPercent;
  }

  getDiscountFromPriceAdjustment(selling_plan, price_adjustment) {
    const discount = {
      percent: 0,
      amount: 0,
      absolute: 0,
    }

    let multiplier = 1
    let totalTime;

    let sellingPlanGroup = this.product.selling_plan_groups.find(group => group.selling_plans.some(plan => plan.id == selling_plan.id))

    if (sellingPlanGroup?.name === 'Prepaid') {
      const str = selling_plan.name // replace with your string

      totalTime = this.calculateTotalDuration(str, false)

      const intervalDate = /\b\d+\s*(days|weeks|months|years)\b/gi
      const intervalDateMatches = str.match(intervalDate)

      if (intervalDateMatches?.length) {
        const intervals = intervalDateMatches[0].match(/\d+/g)
        multiplier = intervals[0] / (intervals[1] || 1)
        multiplier = multiplier > 1 ? multiplier : 1
      }
    }

    const price = this.selectedVariant.price
    const compareAtPrice = this.selectedVariant.compare_at_price && this.selectedVariant.compare_at_price > price ? this.selectedVariant.compare_at_price : price

    switch (price_adjustment.value_type) {
      case 'percentage':
        discount.percent = price_adjustment.value
        discount.absolute = Math.round((price * price_adjustment.value) / 100.0)
        discount.amount = Math.round((price * price_adjustment.value) / 100.0)
        break
      case 'fixed_amount':
        discount.percent = Math.round(((price_adjustment.value * 1.0) / price) * 100.0)
        discount.absolute = price_adjustment.value
        discount.amount = price_adjustment.value
        break
      case 'price':
        discount.percent = selling_plan?.options?.[0]?.name =='Prepaid' ? this.getPrepayDiscountPercent(price, totalTime, price_adjustment.value) : Math.round((((compareAtPrice * multiplier - price_adjustment.value) * 1.0) / (compareAtPrice * multiplier)) * 100.0)
        discount.absolute = compareAtPrice * multiplier - price_adjustment.value
        discount.amount = price - price_adjustment.value
        break
    }

    return discount
  }
  // !SECTION: Discount Functions
  price(selling_plan, formatted = true) {
    if (this.rule) {
      return formatted
        ? this.money(this.selectedVariant.price - this.discount(selling_plan).amount - this.selectedVariant.price * (this.rule.discountAmount / 100))
        : this.selectedVariant.price - this.discount(selling_plan).amount - this.selectedVariant.price * (this.rule.discountAmount / 100)
    }

    return formatted ? this.money(this.selectedVariant.price - this.discount(selling_plan).amount) : this.selectedVariant.price - this.discount(selling_plan).amount
  }

  // Updates element data to be registered by forms
  updateForm() {
    let $sellingPlan = this.querySelector('input[name=selling_plan]')

    if ($sellingPlan) {
      $sellingPlan.value = this.selectedSellingPlan ? this.selectedSellingPlan.id : ''
      $sellingPlan.dispatchEvent(new Event('change'))
    }
  }

  // SECTION: Additional Functionality
  updateURLParams() {
    const url = new URL(window.location.href)

    if (this.selectedSellingPlan) {
      url.searchParams.set('selling_plan', this.selectedSellingPlan.id)
      window.history.replaceState({}, '', url.href)
    } else {
      url.searchParams.delete('selling_plan')
      window.history.replaceState({}, '', url.href)
    }
  }

  // Runs a fetch request to add the selectedVariant to the cart with the passed quantity and selectedSellingPlan
  addToCart(quantity) {
    const items = [
      {
        id: this.selectedVariant.id,
        quantity: quantity,
        ...(this.selectedSellingPlan && {
          selling_plan: this.selectedSellingPlan?.id,
        }),
      },
    ]

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items,
      }),
    })
      .then(response => response.json())
      .then(response => {
        this.log('Added item to cart: ', response)
        //dispatch CustomEvent to tell document that an item was added to cart
        const event = new CustomEvent(`skio::added-to-cart`, {
          bubbles: true,
          composed: true,
          detail: {
            response,
            key: this.key,
          },
        })

        this.dispatchEvent(event)
      })
      .catch(error => {
        this.error(`SKIO ${this.key} error adding item to cart: `, error)
      })
  }

  fetchProduct = handle => {
    return fetch(`/products/${handle}.js`)
      .then(response => response.json())
      .then(product => {
        this.product = product
        this.selectedVariant = product.variants[0]

        return product
      })
  }
  // !SECTION: Additional Functionality

}

if (!customElements.get('skio-plan-picker')) {
  customElements.define('skio-plan-picker', SkioPlanPicker)
}

document.addEventListener('DOMContentLoaded', function() {
  const shadowHost = document.getElementById('skio-subscription-widget');
  const shadowRoot = shadowHost.shadowRoot

  const learnMoreButton = shadowRoot.querySelector('.learn_more__button');

  if (learnMoreButton) {
      learnMoreButton.addEventListener('click', function() {
          console.log('Learn More Clicked');
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', 'TqkEnN']);
      });
  } else {
      console.error("Element with class 'learn_more__button' not found.");
  }
});

if (window) window.SkioPlanPicker = SkioPlanPicker

/* UMG Progo 9/2: flag keyboard use so the plan focus ring only shows for keyboard users */
window.addEventListener('keydown',function(){document.querySelectorAll('skio-plan-picker').forEach(function(el){el.setAttribute('data-ff-kb','');});},{capture:true,passive:true});
